"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("react");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const common_components_1 = require("@yandex-int/pythia-libs/lib/common-components");
const markdown_renderer_1 = __importDefault(require("@yandex-int/pythia-libs/lib/markdown-renderer"));
const hidden_badge_1 = __importDefault(require("../badges/hidden-badge"));
const table_attachment_block_styles_1 = __importDefault(require("./table-attachment-block.styles"));
const b = b_1.default.with('table-attachment-block');
const i18n = (0, i18n_1.default)(['labels']);
// @ts-expect-error TS(2345): Argument of type 'readonly ["blockquote", "fence",... Remove this comment to see the full error message
const markdownRenderer = (0, markdown_renderer_1.default)(common_components_1.MARKDOWN_OPTIONS);
function TableAttachmentBlock(props) {
    const { label, attachments, onImageClick, isHidden } = props;
    const [isfullyRendered, setIsFullyRendered] = (0, react_1.useState)(false);
    const questionLabel = markdownRenderer(label);
    const shouldRenderOriginalImageSize = (e) => {
        const image = e.target;
        if (image.naturalWidth < image.width && image.naturalHeight < image.height) {
            image.style.objectFit = 'none';
            setIsFullyRendered(true);
        }
    };
    const handleOnClick = url => {
        if (!isfullyRendered) {
            onImageClick(url);
            return;
        }
        return false;
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: table_attachment_block_styles_1.default }, { children: [isHidden && (0, jsx_runtime_1.jsx)(hidden_badge_1.default, { text: i18n(['rowHidden']), className: b({ rowBadge: true }) }), label && ((0, jsx_runtime_1.jsx)("div", { className: b('option-row-text'), 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: questionLabel } })), attachments === null || attachments === void 0 ? void 0 : attachments.map(({ url }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('image-container', { zoomable: !isfullyRendered }), onClick: () => handleOnClick(url) }, { children: [!isfullyRendered && ((0, jsx_runtime_1.jsx)("div", { className: b('zoom'), onClick: () => handleOnClick(url) })), (0, jsx_runtime_1.jsx)("img", { className: b('column-image'), src: url, onLoad: shouldRenderOriginalImageSize })] }), url)))] })));
}
exports.default = TableAttachmentBlock;
